import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Icon } from '@codex/icons';


const ViewSwitchWrapper = styled.div`
    display: table;
    position: absolute;
    right: 0;
    top: 9px;
    ${({ theme }) => css`
       @media ${theme.breakpoints.mobile} {
         top: 65px;
       }
     `};
  `;

const ViewSwitchTitle = styled.span`
    display: table-cell;
    vertical-align: middle;
    
      ${({ theme }) => css`
       @media ${theme.breakpoints.mobile} {
         display: none;
       }
     `};
  `;

const ButtonWrapper = styled.div`
    display: table-cell;
    vertical-align: middle;
    
    ${({ theme }) => css`
      &:first-of-type {
        border-right: 2px solid ${theme.colors.shades[5]};
      }
      &:last-of-type button {
        padding-right: 0;
      }
    `};
  `;

const ViewSwitchButton = styled.button`
    display: table;
    padding: 0 8px;
    
    ${({ theme }) => css`
      color: ${theme.colors.link.default};
      @media ${theme.breakpoints.desktop} {
        padding-left: 13px;
        padding-right: 13px;
      }
      &.disabled {
        color: ${theme.colors.shades[4]};
        cursor: not-allowed;
      }
    `};
  `;

const ViewSwitchIconWrapper = styled.span`
    display: table-cell;
    vertical-align: middle;
    
    ${({ theme }) => css`
      fill: ${theme.colors.link.default};
      stroke: ${theme.colors.link.default};
    `};
  `;

const ViewSwitchIcon = styled(Icon)`
      margin: 0 4px 0 0;
      width: 25px;
      height: 25px;
  `;

const ViewSwitchLabel = styled.span`
    display: table-cell;
    vertical-align: middle;
  `;


export default function ViewSwitch({ activeView, title, gridButtonLabel, listButtonLabel, onEnabledButtonClick }) {

  return (
    <ViewSwitchWrapper>
      <ViewSwitchTitle>{title}</ViewSwitchTitle>
      <ButtonWrapper>
        <ViewSwitchButton
          className={activeView === 'grid' || activeView === 'none' ? 'disabled' : ''}
          onClick={(e) => {
            if (activeView !== 'grid') {
              onEnabledButtonClick({ ...e, activeView: 'grid' });
            }
          }}
        >
          <ViewSwitchIconWrapper>
            <ViewSwitchIcon icon={'GridView'} size={'large'} />
          </ViewSwitchIconWrapper>
          <ViewSwitchLabel>
            {gridButtonLabel}
          </ViewSwitchLabel>
        </ViewSwitchButton>
      </ButtonWrapper>
      <ButtonWrapper>
        <ViewSwitchButton
          className={activeView === 'list' || activeView === 'none' ? 'disabled' : ''}
          onClick={(e) => {
            if (activeView !== 'list') {
              onEnabledButtonClick({ ...e, activeView: 'list' });
            }
          }}
        >
          <ViewSwitchIconWrapper>
            <ViewSwitchIcon icon={'ListView'} size={'large'} />
          </ViewSwitchIconWrapper>
          <ViewSwitchLabel>
            {listButtonLabel}
          </ViewSwitchLabel>
        </ViewSwitchButton>
      </ButtonWrapper>
    </ViewSwitchWrapper>
  );
}


ViewSwitch.propTypes = {
  activeView: PropTypes.oneOf(['grid', 'list', 'none']),
  title: PropTypes.string,
  gridButtonLabel: PropTypes.string,
  listButtonLabel: PropTypes.string,
  onEnabledButtonClick: PropTypes.func
};

ViewSwitch.defaultProps = {
  activeView: 'grid',
  title: 'View:',
  gridButtonLabel: 'Grid',
  listButtonLabel: 'List',
  onEnabledButtonClick: () => {}
};
